import {
  getCourseList,
  getCourseListByPost,
  getExamList,
} from "../../api/service.js";
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import de from "element-ui/src/locale/lang/de";
import CameraDialog from "../../views/CameraDialog/CameraDialog.vue";
import fa from "element-ui/src/locale/lang/fa";
import number from "less/lib/less/functions/number";
import md5 from "js-md5";
import http from "../../api/module";
import { setTimeout } from "core-js";

let that;

if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
  // Firefox 38+ seems having support of enumerateDevicesx
  navigator.enumerateDevices = function(callback) {
    navigator.mediaDevices.enumerateDevices().then(callback);
  };
}
var MediaDevices = [];
var isHTTPs = location.protocol === "https:";
var canEnumerate = false;

if (
  typeof MediaStreamTrack !== "undefined" &&
  "getSources" in MediaStreamTrack
) {
  canEnumerate = true;
} else if (
  navigator.mediaDevices &&
  !!navigator.mediaDevices.enumerateDevices
) {
  canEnumerate = true;
}

var hasMicrophone = false;
var hasSpeakers = false;
var hasWebcam = false;

var isMicrophoneAlreadyCaptured = false;
var isWebcamAlreadyCaptured = false;

export default {
  components: {
    HeadCom,
    FooterCom,
    CameraDialog,
  },
  data() {
    return {
      firstTake: false, //课程中间是否拍过照
      midTake: false, //课程中间是否拍过照
      lastTake: false, //课程中间是否拍过照
      questionsTime: 0, //需要答题的次数
      select: "hh",
      player: null,
      playTime: 0,
      show: true,
      liSelected: "100",
      playHeight: "400",
      remove: false,
      current: -1,
      vid: "",
      ccId: "",
      start: 0,
      overStaus: "",
      packagebagId: "",
      courseId: "",
      empStudyId: "",
      courseName: "",
      intervalid1: null,
      timeOut: null,
      timeTest: null,
      timeTest1: null,
      testForm: {
        vertical: "",
        checkboxList: [],
      },
      interval: null,
      autoPlay: true,
      baseInfoCatalogList: [],
      empHeadportrait: "",
      coursePic: "",
      resouceHours: 0,
      isSave: false,
      playData: {},
      oldTokenId: "",
      oldPlayTime: 0,
      playObj: {},
      abnormalOldPlayTime: 0,
      regId: "",
      courseConfig: {},
      dialogTableVisible: false,
      imgUrl: "",
      muLuHeight: {
        height: window.innerHeight - 300 + "px",
      },
      djsTime: 0,
      showQuestion: false,
      overStatus: "",
      hasQuestionnaire: false, //满意度调查问卷
      isQuestionShow: false,
      trainEvaluation: "", //培训评价
      trainEffect: "", //培训效果
      courseUsefulness: "", //课程实用性
      courseRichInteresting: "", //课程丰富
      trainInstructiveForWork: "", //培训对实际工作的指导性
      courseContentSatisfaction: "", //课程内容满意度
      knowledgeMastery: "", //知识的掌握
      wishCourseForWhat: "", //希望培训课程
      teachingSatisfaction: "", //教学满意度
      teachingContentAccept: "", //教学内容接受程度
      meetExpectations: "", //满足预期
      masteryAbilityForOver: "", //掌握能力知识
      recommendations: "", //建议
      comparisonMsg: "",
      resDataMsg: "", //是否显示继续看课按钮
      resDataStatus: -1,
      isDisabled: false, //
      loadingPhoto: false, //
      isPhoto: true, //显示扫描框
    };
  },
  beforeCreated() {},
  created() {
    that = this;
    if (sessionStorage.getItem("token") == undefined) {
      this.$message.error("抱歉！不允许打开多个页面窗口同时进行学习");
      return false;
    }

    localStorage.setItem("oldTokenId", localStorage.getItem("tokenId"));
    that.oldTokenId = localStorage.getItem("oldTokenId");
    this.playData = JSON.parse(localStorage.getItem("playData")); //课程详情页面进入播放页面存入的播放所需参数
    this.courseId = this.$route.query.course;
    this.regId = this.$route.query.reg;
    this.ccId = this.$route.query.ccId;
    this.empHeadportrait = localStorage.getItem("empHeadportrait"); //获取学员头像
    if (localStorage.getItem("dataType") == 1) {
      localStorage.setItem("haveSeenClass", true);
    }
    this.getCourseConfig();
    // setTimeout(function() {
    //     that.$refs.camera.setImage('test');
    // }, 10000)
  },
  mounted() {
    this.getScreenHeight();
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(that.intervalid1);
    clearInterval(that.timeOut);
    clearInterval(that.timeTest);
    clearInterval(that.timeTest1);
    that.intervalid1 = null;
    clearInterval(that.interval);
    that.interval = null;
    next();
  },
  beforeDestroy() {
    if (that.courseConfig.camera) {
      that.$refs.camera.stopNavigator();
    }
    if (that.courseConfig.camera2) {
      that.$refs.camera2.stopNavigator();
    }
    clearInterval(that.intervalid1);
    clearInterval(that.timeOut);
    clearInterval(that.timeTest);
    clearInterval(that.timeTest1);
    that.intervalid1 = null;
    clearInterval(that.interval);
    that.interval = null;
    /**保利威替换 start */
    // that.player.destroy(); // 销毁播放器，包括HTML5和flash播放器
    /**保利威替换 end */
    // window.j2s_stopVideo()
  },

  methods: {
    //提交问卷
    onSubmit() {
      if (
        that.trainEvaluation == "" ||
        that.trainEffect == "" ||
        that.courseUsefulness == "" ||
        that.courseRichInteresting == "" ||
        that.trainInstructiveForWork == "" ||
        that.courseContentSatisfaction == "" ||
        that.knowledgeMastery == "" ||
        that.wishCourseForWhat == "" ||
        that.teachingSatisfaction == "" ||
        that.teachingContentAccept == "" ||
        that.meetExpectations == "" ||
        that.masteryAbilityForOver == "" ||
        that.recommendations == ""
      ) {
        that.$message.warning({
          message: "请完成在线培训满意度调查",
          duration: 1000,
        });
        return false;
      } else {
        let entpId = sessionStorage.getItem("entpId");
        let data = {
          regId: that.regId,
          entpId: entpId,
          trainEvaluation: that.trainEvaluation, //培训评价
          trainEffect: that.trainEffect, //培训效果
          courseUsefulness: that.courseUsefulness, //课程实用性
          courseRichInteresting: that.courseRichInteresting, //课程丰富
          trainInstructiveForWork: that.trainInstructiveForWork, //培训对实际工作的指导性
          courseContentSatisfaction: that.courseContentSatisfaction, //培训对实际工作的指导性
          knowledgeMastery: that.knowledgeMastery, //培训对实际工作的指导性
          wishCourseForWhat: that.wishCourseForWhat, //培训对实际工作的指导性
          teachingSatisfaction: that.teachingSatisfaction, //培训对实际工作的指导性
          teachingContentAccept: that.teachingContentAccept, //培训对实际工作的指导性
          meetExpectations: that.meetExpectations, //培训对实际工作的指导性
          masteryAbilityForOver: that.masteryAbilityForOver, //培训对实际工作的指导性
          recommendations: that.recommendations, //培训对实际工作的指导性
        };
        http.getQuestionnaire(data).then((res) => {
          if (res.data.success) {
            that.$message.success({
              message: res.data.message,
              duration: 1000,
            });
            this.isQuestionShow = false;
          }
        });
      }
    },
    // 生成指定位数随机数
    randomStr(digit) {
      if (digit == "" || isNaN(digit)) {
        console.log("请输入数字");
      } else {
        let sourceStr = "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G";
        let arrStr = sourceStr.split(",");
        let result = ""; //定义变量并初始化
        let index = 0;
        for (let i = 0; i < digit; i++) {
          index = parseInt(Math.random() * arrStr.length);
          result += arrStr[index];
        }
        return result;
      }
    },
    //获取视频配置信息
    getCourseConfig() {
      let url = "/videoPlay/getCourseConfig";
      let data = {
        courseId: this.courseId,
      };
      getCourseList(url, data).then((res) => {
        if (res.success) {
          that.courseConfig = res.data;
          if (that.courseConfig.camera) {
            that.checkDeviceSupport(function() {
              // 检测是否安装摄像头--
              if (hasWebcam == false) {
                that.$message.warning({
                  message: "捕获摄像头失败，请安装摄像头！",
                  duration: 1000,
                });
                // console.log("没有摄像头！");
                return false;
              } else {
                that.getCourseBaseInfoCatalog();
                // if(isWebcamAlreadyCaptured == false){
                //   // console.log("捕获摄像头失败，请重新安装摄像头！");
                //   this.$message.warning({
                //     message: '捕获摄像头失败，请重新安装摄像头！',
                //     duration: 1000
                //   })
                //   return false;
                // }else{
                //   that.getCourseBaseInfoCatalog();
                // }
              }
            });
          } else {
            that.getCourseBaseInfoCatalog();
          }
        }
      });
    },
    //获取目录和详情,调取播放器
    getCourseBaseInfoCatalog() {
      let url = "/myCourse/getCourseDetails";
      let data = {
        courseId: this.courseId,
        ccId: this.ccId,
        regId: that.regId,
      };
      getCourseList(url, data).then((res) => {
        if (res.success) {
          that.baseInfoCatalogList = res.data.catalog;
          that.coursePic = res.data.coursePic;
          that.courseName = res.data.courseName;
          that.overStatus = res.data.overStatus;
          that.hasQuestionnaire = res.data.hasQuestionnaire;
          let url2 = "/videoPlay/getVideoId";
          if (that.$route.query.ccId == undefined) {
            that.ccId = that.baseInfoCatalogList[0].subCatalog[0].ccId;
            that.overStaus =
              that.baseInfoCatalogList[0].subCatalog[0].overStaus;
            that.resouceHours =
              that.baseInfoCatalogList[0].subCatalog[0].resouceHours;
          } else {
            that.baseInfoCatalogList.forEach(function(bObj, _index) {
              bObj.subCatalog.forEach(function(sObj, _sub) {
                if (sObj.ccId == that.$route.query.ccId) {
                  that.ccId = sObj.ccId;
                  that.overStaus = sObj.overStaus;
                  that.resouceHours = sObj.resouceHours;
                  that.liSelected = _index + "-" + _sub;
                }
              });
            });
          }
          let data2 = {
            ccId: that.ccId,
            regId: that.regId,
          };
          getCourseList(url2, data2).then((res2) => {
            if (res2.success) {
              that.vid = res2.data.videoId;
              that.start = Number(res2.data.lastTime);
              that.playerStart();
            } else {
              this.$message.error(res2.message);
            }
          });
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //播放器
    playerStart($vid) {
      //易测云播放器 此处加了一个入参
      console.log($vid);
      let _this = this;
      // clearInterval(this.timeOut);
      // clearInterval(this.timeTest);
      // clearInterval(this.timeTest1);
      // var sI = null;
      // clearInterval(sI);
      // if (_this.courseConfig.camera) {
      //     this.timeOut = setTimeout(function() {
      //             that.player.j2s_pauseVideo();
      //             that.dialogTableVisible = true;
      //         }, 600000) /*600000*/ // 10分钟后进行拍照
      // }
      this.isSave = false;
      // this.player = polyvObject('#player').videoPlayer({
      //     'width': 'auto',
      //     'height': that.playHeight,
      //     'list_id': 'id',
      //     'forceH5': true,
      //     'speed': false,
      //     'ignoreIE': true,
      //     'ban_seek_by_limit_time': 'off',
      //     // 'ban_seek_by_limit_time': 'on', // 禁止拖动*/
      //     /*that.courseConfig.seek?"off":"on", // 进度条拖动*/
      //     // "autoplay": that.autoPlay,
      //     "autoplay": false,
      //     "watchStartTime": that.start,
      //     ban_history_time: 'on',
      //     'flashvars': {
      //         'allowscriptaccess': "always",
      //         'allowNetworking': "all",
      //         "setScreen": "16_9",
      //     },
      //     'vid': this.vid
      // });

      // console.log(this.player.j2s_seekVideo)
      sessionStorage.setItem(
        "courseLogObj",
        JSON.stringify({
          ccId: this.ccId,
          regId: that.regId,
        })
      );

      if (_this.start > 0) {
        _this.oldPlayTime = _this.start;
      } else {
        _this.oldPlayTime = 0;
      }
      window.s2j_onVideoPlay = function() {
        //视频开始播放
        console.log("开始监听播放");
        clearInterval(_this.intervalid1);
        _this.intervalid1 = null;
        clearInterval(_this.interval);
        _this.interval = null;
        //视频开始播放
        _this.intervalid1 = setInterval(() => {
          if (_this.overStaus == 1) {
            _this.saveUserCourseStudingData(1);
          } else {
            _this.saveUserCourseStudingData(0);
          }
        }, 120000); //120000
        _this.getCourseCatalog();
        _this.interval = setInterval(_this.render, 1000);
      };
      window.s2j_onVideoPause = function() {
        //视频暂停播放
        clearInterval(_this.intervalid1);
        clearInterval(_this.interval);
      };
      window.s2j_onPlayOver = function() {
        //视频播放完成
        clearInterval(_this.timeOut);
        clearInterval(_this.timeTest);
        clearInterval(_this.timeTest1);
        clearInterval(_this.intervalid1);
        clearInterval(_this.interval);
        _this.autoPlay = false;
        
        _this.saveUserCourseStudingData(1);
        if (that.courseConfig.camera) {
          if (_this.overStaus == 1) {
            /**保利威替换 start */
            // _this.player.j2s_pauseVideo(); // 暂停播放当前视频
            /**保利威替换 end */
            /**易测云播放器 start */
            _this.$refs.ycyPlayer.pause(); // 暂停播放当前视频
            /**易测云播放器 end */
            _this.dialogTableVisible = true;
          } else {
            // that.$refs.camera.setImage();
          }
        }
        $("#player").css("display", "none");
        $("#buylink").css("display", "block");
        $("#startScreen").css("display", "none");
        let parent = _this.liSelected.split("-")[0];
        let child = _this.liSelected.split("-")[1];
        _this.baseInfoCatalogList.map((item, index) => {
          //播放完成之后立马显示已经完成的图标
          if (index == parent) {
            let cousecate = item.cousecate;
            cousecate.map((temp, sub) => {
              if (sub == child) {
                temp.overStaus = 1;
              }
            });
          }
        });
        setTimeout(function() {
          _this.getCourseCatalog();
        }, 500);
      };
      /**易测云播放器start */
      //调整到最后改变vid，播放器自动播放视频
      //在此之前，startTime（播放开始时间），
      //  dragEnable（是否可拖拽）先改变好
      if ($vid) {
        this.vid = $vid;
      }
    },
    ycyOnPlay() {
      console.log("ycyOnPlay");
      if (window.s2j_onVideoPlay) {
        window.s2j_onVideoPlay();
      }
    },
    ycyOnPause() {
      console.log("ycyOnPause");
      if (window.s2j_onVideoPause) {
        window.s2j_onVideoPause();
      }
    },
    ycyOnEnded() {
      console.log("ycyOnEnded");
      if (window.s2j_onPlayOver) {
        window.s2j_onPlayOver();
      }
    },
    //保存视频时长
    saveUserCourseStudingData(isOver) {
      if (
        !localStorage.getItem("tokenId") ||
        localStorage.getItem("tokenId") == ""
      ) {
        /**保利威替换 start */
        // that.player.destroy(); // 销毁播放器，包括HTML5和flash播放器
        /**保利威替换 end */
        this.$alert("账号登录失效，请退出后重新登录！", "提示", {
          confirmButtonText: "确定",
          showClose: false,
          callback: (action) => {
            this.$router.push({
              name: "home",
            });
            sessionStorage.setItem("$isUserLogin", false);
          },
        });
      } else if (that.oldTokenId != localStorage.getItem("tokenId")) {
        //两个账号登陆
        /**保利威替换 start */
        // that.player.destroy(); // 销毁播放器，包括HTML5和flash播放器
        /**保利威替换 end */
        this.open();
      } else {
        let url = "/videoPlay/saveStudyRecord";
        let randomStr_12 = this.randomStr(12);
        let sign =
          "courseOver=" +
          isOver +
          "&regId+" +
          that.regId +
          "&random=" +
          randomStr_12 +
          "&keySigniDZ4s7oizTZ60b%^KU";
        let signMd5 = md5(sign);
        let params = {
          random: randomStr_12,
          sign: signMd5,
          courseId: that.courseId, // 课程Id
          // empStudyId: this.empStudyId?this.empStudyId:"null",
          ccId: that.ccId, //视频VID
          regId: that.regId, //视频VID
          courseDelayTime: that.playTime, //视频播放时长
          courseOver: isOver,
          tokenId: localStorage.getItem("tokenId"),
        };
        // let data = {
        //   data:Base64.encode(JSON.stringify(params))
        // }
        getCourseListByPost(url, params).then((res) => {
          if (res.success) {
            if (isOver == 1) {
              this.isSave = true; //当保存时长成功之后，不再进行二次保存
              setTimeout(function() {
                let parent = that.liSelected.split("-")[0];
                let child = that.liSelected.split("-")[1];
                /* that.baseInfoCatalogList.map((item, index) => {  //播放完成之后立马显示已经完成的图标
                                   if (index == parent) {
                                     let cousecate = item.cousecate
                                     cousecate.map((temp, sub) => {
                                       if (sub == child) {
                                         temp.overStaus = 1
                                       }
                                     })
                                   }
                                 })*/
                that.getCourseCatalog();
              }, 500);
              /* that.getCourseBaseInfoCatalog();*/
            }
          } else {
            // ------------------------- begin 视频进度条异常，回退 begin -------------------------
            if (
              res.message &&
              res.message.includes(
                "视频观看进度异常，或未拍摄照片将回退视频进度节点"
              )
            ) {
                this.videoPlayError(res);
              return;
            }
            // ------------------------- end 视频进度条异常，回退 end -------------------------
            // ------------------------- begin 请先学完进行中的视频，不能跳跃学习 begin -------------------------
            if (
                res.message &&
                res.message.includes(
                  "请先学完进行中的视频，不能跳跃学习"
                )
              ) {
                  this.videoJumpError(res);
                return;
              }
              // ------------------------- end 请先学完进行中的视频，不能跳跃学习 end -------------------------
            this.$message.error(res.message);
            /**保利威替换 start */
            // this.player.j2s_pauseVideo(); // 暂停播放当前视频
            /**保利威替换 end */
            /**易测云播放器 start */
            this.$refs.ycyPlayer.pause(); // 暂停播放当前视频
            /**易测云播放器 end */
            if (res.code == 2202) {
              //登陆失效
              /**保利威替换 start */
              // that.player.destroy(); // 销毁播放器，包括HTML5和flash播放器
              /**保利威替换 end */
              this.$alert("账号登录失效，请退出后重新登录！", "提示", {
                confirmButtonText: "确定",
                showClose: false,
                callback: (action) => {
                  this.$router.push({
                    name: "home",
                  });
                  sessionStorage.setItem("$isUserLogin", false);
                },
              });
            } else if (res.code == 2203) {

              // ======================== begin 视频进度条异常，回退(旧) begin ========================
              // that.abnormalOldPlayTime = JSON.parse(
              //   JSON.stringify(that.oldPlayTime)
              // );
              // this.$message({
              //   type: "warning",
              //   message: res.message,
              // });
              // that.play(
              //   that.playObj.vid,
              //   that.playObj.ccId,
              //   that.playObj.courseDelayTime,
              //   that.playObj.index,
              //   that.playObj.sub,
              //   that.playObj.courseOver,
              //   that.playObj.overStaus,
              //   that.playObj.resouceHours
              // );

              // /**保利威视频替换 start */
              // // that.player.j2s_seekVideo(that.abnormalOldPlayTime);
              // /**保利威视频替换 end */

              // /**易测云播放器 start */
              // that.$refs.ycyPlayer.jumpToTime(that.abnormalOldPlayTime);
              // /**易测云播放器 end */
              // ======================== end 视频进度条异常，回退(旧) end ========================

              // ======================== begin 视频进度条异常，回退(新) begin ========================
              that.videoSeekBack(that.oldPlayTime);
              // ======================== end 视频进度条异常，回退(新) end ========================
            }
          }
        });
      }
    },
    videoSeekBack(time) {
      // 更新播放数据，设置回退视频进度
      const playData = this.playData || {};
      const updatedPlayData = {
        ...playData,
        courseDelayTime: time,
      };
      localStorage.setItem("playData", JSON.stringify(updatedPlayData));

      // 更新路由参数（使用 replace 避免在历史记录中留下记录）
      this.$router.replace({
        query: {
          ...this.$route.query,
          course: this.courseId,
          reg: this.regId,
          ccId: this.ccId,
        },
      });

      // 重新加载页面以重置播放器状态
      window.location.reload();
    },
    videoPlayError(res) {
      // 弹出确认框（无取消），暂停当前播放；确认后跳转到后端返回的时间点继续播放
      /**易测云播放器 start */
      that.$refs.ycyPlayer && that.$refs.ycyPlayer.pause();
      /**易测云播放器 end */
      that
        .$confirm(res?.message || '视频播放异常，请重新播放', "提示", {
          confirmButtonText: "确认",
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          this.videoSeekBack(res.data);
        });
    },
    videoJumpError(res) {
        // 弹出确认框（无取消），暂停当前播放；确认后跳转到后端返回的时间点继续播放
        /**易测云播放器 start */
        that.$refs.ycyPlayer && that.$refs.ycyPlayer.pause();
        /**易测云播放器 end */
        that
          .$confirm(res?.message || '视频播放异常，请重新播放', "提示", {
            confirmButtonText: "确认",
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            type: "warning",
          })
          .then(() => {
            that.$router.go(-1);
          });
    },
    getEnterpriseWebsite() {
      //根据域名获取企业id
      var eUrl = window.location.href;
      // var eUrl="http://www.eceping.net"
      //  var eUrl="http://hnpx.enterprise.eceping.net"
      var param = {
        entpWebsite: eUrl /*eUrl.substring(0,eUrl.indexOf(":",5))*/,
      };
      let url = "enterprise/getEnterpriseWebsite";
      getBizList(url, param).then((res) => {
        if (res.success) {
          localStorage.setItem("enterpriseId", res.data.entpId);
          localStorage.setItem("entpCreditNo", res.data.entpCreditNo);
        }
      });
    },
    //获取目录和详情
    getCourseCatalog() {
      let url = "/myCourse/getCourseDetails";
      let data = {
        courseId: this.courseId,
        regId: this.regId,
      };
      getCourseList(url, data).then((res) => {
        if (res.success) {
          this.baseInfoCatalogList = res.data.catalog;
          this.overStatus = res.data.overStatus;
          this.hasQuestionnaire = res.data.hasQuestionnaire;
          if (this.overStatus == 1 && this.hasQuestionnaire == false) {
            /**保利威替换 start */
            // this.player.j2s_pauseVideo(); // 暂停播放当前视频
            /**保利威替换 end */
            /**易测云播放器 start */
            this.$refs.ycyPlayer.pause(); // 暂停播放当前视频
            /**易测云播放器 end */
            this.isQuestionShow = true;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //选中某一条视频进行播放
    play(
      vid,
      ccId,
      courseDelayTime,
      index,
      sub,
      courseOver,
      overStaus,
      resouceHours
    ) {
      if (localStorage.getItem("dataType") == 1) {
        localStorage.setItem("haveSeenClass", true);
      }
      that.overStaus = overStaus;
      that.questionsTime = 0;
      that.resouceHours = resouceHours;
      that.firstTake = false;
      that.midTake = false;
      that.lastTake = false;
      // if (that.overStaus == 1 && that.courseConfig.camera) {
      //     /**保利威替换 start */
      //     // this.player.j2s_pauseVideo(); // 暂停播放当前视频
      //     /**保利威替换 end */
      //     /**易测云播放器 start */
      //     that.$refs.ycyPlayer.pause(); // 暂停播放当前视频
      //     /**易测云播放器 end */
      //     that.dialogTableVisible = true;
      // }
      let url = "/videoPlay/getVideoId";
      let data = {
        ccId: ccId,
        regId: this.regId,
      };
      sessionStorage.setItem("courseLogObj", JSON.stringify(data));
      getCourseList(url, data).then((res) => {
        if (res.success) {
          that.ccId = ccId;
          that.playObj = {
            vid: vid,
            ccId: ccId,
            courseDelayTime: courseDelayTime,
            index: index,
            sub: sub,
            courseOver: courseOver,
            overStaus: overStaus,
            resouceHours: resouceHours,
          };
          if (that.player) {
            /**保利威替换 start */
            // that.player.destroy(); // 销毁播放器，包括HTML5和flash播放器
            /**保利威替换 end */
          }
          $("#player").css("display", "block");
          $("#buylink").css("display", "none");
          $("#startScreen").css("display", "none");
          that.current = index;
          that.select = index + "s";
          /**保利威替换 start */
          // that.vid = res.data.videoId;
          /**保利威替换 end */
          /**易测云播放器 start */
          let $vid = res.data.videoId;
          /**易测云播放器 end */
          that.start = res.data.lastTime;
          that.liSelected = index + "-" + sub;
          that.overStaus = overStaus;
          // this.autoPlay = true
          /**易测云播放器 start */
          that.autoPlay = false;
          /**易测云播放器 end */
          that.playerStart($vid); //易测云播放器 此处加了一个入参
        } else {
          if (res.code == 2202) {
            this.$alert("账号登录失效，请退出后重新登录！", "提示", {
              confirmButtonText: "确定",
              showClose: false,
              callback: (action) => {
                this.$router.push({
                  name: "home",
                });
                sessionStorage.setItem("$isUserLogin", false);
                if (that.courseConfig.camera) {
                  that.$refs.camera.stopNavigator();
                }
                clearInterval(that.intervalid1);
                clearInterval(that.timeOut);
                clearInterval(that.timetest);
                clearInterval(that.timetest1);
                that.intervalid1 = null;
                clearInterval(that.interval);
                that.interval = null;
                /**保利威替换 start */
                // that.player.destroy(); // 销毁播放器，包括HTML5和flash播放器
                /**保利威替换 end */
              },
            });
          } else {
            that.$message.error(res.message);
          }
        }
      });
    },
    //播放器的记时功能
    render() {
      if (this.overStaus != 1) {
        if (
          /**保利威替换 start */
          // this.player != undefined &&
          // this.player.j2s_getCurrentTime != undefined
          /**保利威替换 end */
          /**易测云播放器 start */
          this.$refs.ycyPlayer != undefined &&
          this.$refs.ycyPlayer.getCurrentTime != undefined
          /**易测云播放器 end */
        ) {
          /**保利威替换 start */
          // this.playTime = this.player.j2s_getCurrentTime();
          /**保利威替换 end */
          /**易测云播放器 start */
          this.playTime = this.$refs.ycyPlayer.getCurrentTime();
          /**易测云播放器 end */
          this.oldPlayTime = this.playTime;
          /**保利威替换 start */
          // let firsrTime = Math.ceil(this.player.j2s_getDuration() *0.1);
          // let midTime = Math.ceil(this.player.j2s_getDuration() *0.5);
          // let lastTime = Math.ceil(this.player.j2s_getDuration() *0.8);
          /**保利威替换 end */
          /**易测云播放器 start */
          let firsrTime = Math.ceil(this.$refs.ycyPlayer.getDuration() * 0.1);
          let midTime = Math.ceil(this.$refs.ycyPlayer.getDuration() * 0.5);
          let lastTime = Math.ceil(this.$refs.ycyPlayer.getDuration() * 0.8);
          /**易测云播放器 end */
          // console.log(999, firsrTime,midTime,lastTime, Math.ceil(this.playTime))
          if (
            this.courseConfig.camera &&
            firsrTime == Math.ceil(this.playTime) &&
            !this.firstTake
          ) {
            // 播放到视频10%
            /**保利威替换 start */
            // this.player.j2s_pauseVideo(); // 暂停播放当前视频
            /**保利威替换 end */
            /**易测云播放器 start */
            this.$refs.ycyPlayer.pause(); // 暂停播放当前视频
            /**易测云播放器 end */
            this.dialogTableVisible = true;
            this.firstTake = true; //记录已经进行中间拍照
          } else if (
            this.courseConfig.camera &&
            midTime == Math.ceil(this.playTime) &&
            !this.midTake
          ) {
            // 播放到视频中部(50%)
            /**保利威替换 start */
            // this.player.j2s_pauseVideo(); // 暂停播放当前视频
            /**保利威替换 end */
            /**易测云播放器 start */
            this.$refs.ycyPlayer.pause(); // 暂停播放当前视频
            /**易测云播放器 end */
            this.dialogTableVisible = true;
            this.midTake = true; //记录已经进行中间拍照
          } else if (
            this.courseConfig.camera &&
            lastTime == Math.ceil(this.playTime) &&
            !this.lastTake
          ) {
            // 播放到视频尾部80%
            /**保利威替换 start */
            // this.player.j2s_pauseVideo(); // 暂停播放当前视频
            /**保利威替换 end */
            /**易测云播放器 start */
            this.$refs.ycyPlayer.pause(); // 暂停播放当前视频
            /**易测云播放器 end */
            this.dialogTableVisible = true;
            this.lastTake = true; //记录已经进行中间拍照
          }
        }
      }
      if (
        /**保利威替换 start */
        // this.player != undefined &&
        // this.player.j2s_getCurrentTime != undefined
        /**保利威替换 end */
        /**易测云播放器 start */
        this.$refs.ycyPlayer != undefined &&
        this.$refs.ycyPlayer.getCurrentTime != undefined
        /**易测云播放器 end */
      ) {
        /**保利威替换 start */
        // this.playTime = this.player.j2s_getCurrentTime();
        /**保利威替换 end */
        /**易测云播放器 start */
        this.playTime = this.$refs.ycyPlayer.getCurrentTime();
        /**易测云播放器 end */
        this.oldPlayTime = this.playTime;
        if (
          that.courseConfig.completeRateFlag &&
          that.courseConfig.completeRateFlag != ""
        ) {
          let resouceHours =
            this.timeToSec(this.resouceHours) *
            (new Number(that.courseConfig.completeRateFlag) / 100);
          if (this.playTime >= resouceHours) {
            //根据配置来
            if (!this.isSave) {
              this.saveUserCourseStudingData(1);
            }
          }
        } else {
          let resouceHours = this.timeToSec(this.resouceHours) - 60;
          if (this.playTime >= resouceHours) {
            //还剩1分钟时调用接口
            if (!this.isSave) {
              this.saveUserCourseStudingData(1);
            }
          }
        }
        // console.log('this.playTime', this.playTime)
        /*  if (this.oldPlayTime != 0 && this.playTime >= this.oldPlayTime + 2) {
                    if (that.courseConfig.seek) {
                      this.player.j2s_seekVideo(this.oldPlayTime)
                    }
                  } else if (this.oldPlayTime == 0 && this.playTime >= this.oldPlayTime + 2) {
                    if (that.courseConfig.seek) {
                      this.player.j2s_seekVideo(this.oldPlayTime++)
                    }
                  } else {
                    this.oldPlayTime = this.playTime;
                    if (that.courseConfig.completeRateFlag && that.courseConfig.completeRateFlag != '') {
                      let resouceHours = this.timeToSec(this.resouceHours) * (new Number(that.courseConfig.completeRateFlag) / 100);
                      if (this.playTime >= resouceHours) {  //根据配置来
                        if (!this.isSave) {
                          this.saveUserCourseStudingData(1)
                        }
                      }
                    } else {
                      let resouceHours = this.timeToSec(this.resouceHours) - 60;
                      if (this.playTime >= resouceHours) {  //还剩1分钟时调用接口
                        if (!this.isSave) {
                          this.saveUserCourseStudingData(1)
                        }
                      }
                    }

                  }*/
        let userPlayRecord =
          localStorage.getItem("userPlayRecord") != undefined
            ? JSON.parse(localStorage.getItem("userPlayRecord"))
            : {};
        let data = {
          //当前播放视频信息
          ccId: this.ccId,
          playTime: this.playTime,
          courseId: this.courseId,
          tokenId: localStorage.getItem("tokenId"),
          time: new Date(),
        };
      }
    },

    //伸缩章节
    pulling(cataLog, event) {
      var el = event.currentTarget;
      let idName = "#" + cataLog;
      let ispull = $(idName).attr("ispull");
      if (ispull == "true") {
        $(idName).removeClass("show");
        $(idName).attr("ispull", "false");
        $(el)
          .find(".up")
          .hide();
        $(el)
          .find(".down")
          .show();
      } else {
        $(idName).addClass("show");
        $(idName).attr("ispull", "true");
        $(el)
          .find(".down")
          .hide();
        $(el)
          .find(".up")
          .show();
      }
    },
    //获取屏幕高度
    getScreenHeight() {
      var clientHeight = document.documentElement.clientHeight;
      var clientWidth = document.documentElement.clientWidth;
      // console.log("可视高度",clientHeight,"可视宽度",clientWidth)
      this.playHeight = clientHeight - 60;
      // console.log(this.playHeight)
      $("#videoPlay").height(this.playHeight);
      $("#playerBox").height(this.playHeight);
      $("#player").height(this.playHeight - 20);
      $("#videoList").height(this.playHeight);
      $("#videoBox").height(this.playHeight);
      $("#buylink").height(this.playHeight);
      $("#startScreen").height(this.playHeight);
    },
    //路由回退
    goBack() {
      that.$router.go(-1);
      /* sessionStorage.setItem("coursePlayGoBack", 1)
            this.$router.replace({
              path: "/courseDetail",
              name: "courseDetail",
              params: {
                courseId: this.courseId,
                packagebagId: this.packagebagId
              }
            }) */
    },

    //将时分秒转换成秒
    timeToSec(time) {
      var hour = time.split(":")[0];
      var min = time.split(":")[1];
      var sec = time.split(":")[2];
      var s = Number(hour * 3600) + Number(min * 60) + Number(sec);
      return s;
    },
    handleOpen() {},
    handleClose() {
      if (that.imgUrl == "") {
        that.$message({
          type: "warning",
          message: "请点击拍照",
        });
      } else {
        that
          .$confirm(
            "请检查已经拍的照片是否是符合规范的照片（人脸全部显示在拍摄区域内），照片不规范将会审核不通过，导致您重新看课",
            "提示",
            {
              confirmButtonText: "已检查，继续看课",
              cancelButtonText: "去检查",
              type: "warning",
              showClose: false, //是否显示右上角的x
              closeOnClickModal: false, //是否可以点击空白处关闭弹窗
            }
          )
          .then(() => {
            that.dialogTableVisible = false;
            /**保利威替换 start */
            // this.player.j2s_resumeVideo();
            /**保利威替换 end */
            /**易测云播放器 start */
            that.$refs.ycyPlayer.play();
            /**易测云播放器 end */
            that.imgUrl = "";
          })
          .catch(() => {});
      }
    },
    open() {
      const h = this.$createElement;
      that.$alert(
        "检测到您已使用其他账号登录，该窗口用户已被替换！请重新登录",
        "提示",
        {
          confirmButtonText: "确定",
          showClose: false,
          callback: (action) => {
            that.$router.push({
              name: "home",
            });
            sessionStorage.setItem("$isUserLogin", false);
          },
        }
      );
      /*     this.$msgbox({
                   title: '提示',
                   message: h('p', null, [
                     h('p', null, '检测到您已使用其他账号登录，该窗口用户已被替换！'),
                     h('p', null, '请确认当前账号是否正确'),
                     // h('i', { style: 'color: teal' }, 'VNode')
                   ]),
                   showClose: false,
                   confirmButtonText: '确定',
                   callback: action => {
                     this.$router.push({name: 'home'})
                     // sessionStorage.setItem("$isUserLogin",false)
                     }
                 });*/
    },
    getUlr(imgUrl) {
      if (imgUrl == "没有检测到头像") {
        /**保利威替换 start */
        // that.player.j2s_pauseVideo(); // 暂停播放当前视频
        /**保利威替换 end */
        /**易测云播放器 start */
        that.$refs.ycyPlayer.pause(); // 暂停播放当前视频
        /**易测云播放器 end */
        that
          .$confirm(
            "系统捕获摄像头异常，建议重新启动摄像头后，再开始进行学习",
            "提示",
            {
              confirmButtonText: "我知道了",
              showCancelButton: false,
              closeOnClickModal: false,
              type: "warning",
            }
          )
          .then(() => {
            that.$router.go(-1);
          })
          .catch(() => {});
      } else {
        that.imgUrl = imgUrl;
        /*
                        var ImgObj=new Image();
                        ImgObj.src= imgUrl;

                        if(ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0))
                        {
                          console.log('有效');
                        } else {
                          console.log('无效');
                        }
                        debugger*/

        let url = "/videoPlay/saveStudyPhoto";
        let data = {
          courseId: that.courseId, // 课程Id
          ccId: that.ccId, //视频VID
          photoUrl: imgUrl,
          regId: that.regId,
        };
        getCourseListByPost(url, data).then((res) => {
          if (res.success) {
            this.loadingPhoto = false;
            setTimeout(() => {
              this.isDisabled = false; // 点击一次时隔两秒后才能再次点击
            }, 2000);
            this.resDataStatus = res.data.status;
            this.comparisonMsg = res.message;
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    getUlr2(imgUrl) {
      if (imgUrl == "没有检测到头像") {
        /**保利威替换 start */
        // that.player.j2s_pauseVideo(); // 暂停播放当前视频
        /**保利威替换 end */
        /**易测云播放器 start */
        that.$refs.ycyPlayer.pause(); // 暂停播放当前视频
        /**易测云播放器 end */
        that
          .$confirm(
            "系统捕获摄像头异常，建议重新启动摄像头后，再开始进行学习",
            "提示",
            {
              confirmButtonText: "我知道了",
              showCancelButton: false,
              closeOnClickModal: false,
              type: "warning",
            }
          )
          .then(() => {
            that.$router.go(-1);
          })
          .catch(() => {});
      } else {
        that.imgUrl = imgUrl;
        let url = "/videoPlay/saveStudyPhoto";
        let data = {
          courseId: that.courseId, // 课程Id
          ccId: that.ccId, //视频VID
          photoUrl: imgUrl,
          regId: that.regId,
        };
        getCourseListByPost(url, data).then((res) => {
          if (res.success) {
            this.loadingPhoto = false;
            setTimeout(() => {
              this.isDisabled = false; // 点击一次时隔两秒后才能再次点击
            }, 2000);
            this.resDataStatus = res.data.status;
            this.comparisonMsg = res.message;
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    savePhone() {
      that.isDisabled = true; // 点击一次时隔两秒后才能再次点击
      that.loadingPhoto = true;
      that.$refs.camera2.setImage();
    },
    resumeVideo() {
      if (that.imgUrl == "") {
        that.$message({
          type: "warning",
          message: "请点击拍照",
        });
      } else {
        that
          .$confirm(
            "请检查已经拍的照片是否是符合规范的照片（人脸全部显示在拍摄区域内），照片不规范将会审核不通过，导致您重新看课",
            "提示",
            {
              confirmButtonText: "已检查，继续看课",
              cancelButtonText: "去检查",
              type: "warning",
              showClose: false, //是否显示右上角的x
              closeOnClickModal: false, //是否可以点击空白处关闭弹窗
            }
          )
          .then(() => {
            if (that.resDataStatus == -1) {
              that.$message({
                type: "error",
                message: that.comparisonMsg,
              });
            } else {
              that.imgUrl = "";
              that.comparisonMsg = "";
              /**保利威替换 start */
              // that.player.j2s_resumeVideo();
              /**保利威替换 end */

              /**易测云播放器 start */
              that.$refs.ycyPlayer.play();
              /**易测云播放器 end */

              that.dialogTableVisible = false;
              that.resDataStatus = -1;

              /**保利威替换 start */
              // this.playTime = this.player.j2s_getCurrentTime();
              /**保利威替换 end */
              /**易测云播放器 start */
              this.playTime = this.$refs.ycyPlayer.getCurrentTime();
              /**易测云播放器 end */
              this.oldPlayTime = this.playTime;

              /**保利威替换 start */
              // let midTime = Math.ceil(this.player.j2s_getDuration() * 0.5)
              /**保利威替换 end */
              /**易测云播放器 start */
              let midTime = Math.ceil(this.$refs.ycyPlayer.getDuration() * 0.5);
              /**易测云播放器 end */
              // console.log('Math.ceil(this.playTime)',Math.ceil(this.playTime))
              // 播放到视频中部(50%)弹练习
              if (
                this.courseConfig.camera &&
                midTime == Math.ceil(this.playTime)
              ) {
                if (that.overStaus != 1) {
                  if (that.questionsTime < 2) {
                    that.questionsTime++;
                    if (localStorage.getItem("dataType") == 1) {
                      that.testForm.checkboxList = undefined;
                      that.testForm.vertical = undefined;
                      /**保利威替换 start */
                      // that.player.j2s_pauseVideo(); // 暂停播放当前视频
                      /**保利威替换 end */
                      /**易测云播放器 start */
                      that.$refs.ycyPlayer.pause(); // 暂停播放当前视频
                      /**易测云播放器 end */
                      if (
                        JSON.parse(localStorage.getItem("haveSeenClass")) ==
                        true
                      ) {
                        that.showQuestion = true;
                        localStorage.setItem("haveSeenClass", false);
                      }
                      that.getquestion();
                    }
                  }
                }
              }
            }
          })
          .catch(() => {});
      }
    },
    checkDeviceSupport(callback) {
      //检测是否安装摄像头
      if (!canEnumerate) {
        return;
      }
      if (
        !navigator.enumerateDevices &&
        window.MediaStreamTrack &&
        window.MediaStreamTrack.getSources
      ) {
        navigator.enumerateDevices = window.MediaStreamTrack.getSources.bind(
          window.MediaStreamTrack
        );
      }

      if (!navigator.enumerateDevices && navigator.enumerateDevices) {
        navigator.enumerateDevices = navigator.enumerateDevices.bind(navigator);
      }

      if (!navigator.enumerateDevices) {
        if (callback) {
          callback();
        }
        return;
      }

      MediaDevices = [];
      navigator.enumerateDevices(function(devices) {
        devices.forEach(function(_device) {
          var device = {};
          for (var d in _device) {
            device[d] = _device[d];
          }

          if (device.kind === "audio") {
            device.kind = "audioinput";
          }

          if (device.kind === "video") {
            device.kind = "videoinput";
          }

          var skip;
          MediaDevices.forEach(function(d) {
            if (d.id === device.id && d.kind === device.kind) {
              skip = true;
            }
          });

          if (skip) {
            return;
          }

          if (!device.deviceId) {
            device.deviceId = device.id;
          }

          if (!device.id) {
            device.id = device.deviceId;
          }

          if (!device.label) {
            device.label = "Please invoke getUserMedia once.";
            if (!isHTTPs) {
              device.label =
                "HTTPs is required to get label of this " +
                device.kind +
                " device.";
            }
          } else {
            if (device.kind === "videoinput" && !isWebcamAlreadyCaptured) {
              isWebcamAlreadyCaptured = true;
            }

            if (device.kind === "audioinput" && !isMicrophoneAlreadyCaptured) {
              isMicrophoneAlreadyCaptured = true;
            }
          }

          if (device.kind === "audioinput") {
            hasMicrophone = true;
          }

          if (device.kind === "audiooutput") {
            hasSpeakers = true;
          }

          if (device.kind === "videoinput") {
            hasWebcam = true;
          }

          // there is no 'videoouput' in the spec.

          MediaDevices.push(device);
        });

        if (callback) {
          callback();
        }
      });
    },
    //提示做完题目才能继续看课
    showQuestionBeforeClose() {
      this.$message({
        message: "请先做完题目才能继续看课",
        type: "warning",
      });
    },
    //获取看课中的题目
    getquestion() {
      let url = "/exercise/exerciseList";
      let data = {
        exerciseType: 2,
        pageSize: 50,
        pageNum: 1,
      };
      getExamList(url, data).then((res) => {
        if (res.success) {
          let url = "/exercise/exerciseDetails";
          let data = {
            exerciseId: res.data[0].id,
          };
          getExamList(url, data).then((response) => {
            this.$nextTick(() => {
              this.testForm =
                response.data.paperEntity.paperAreaList[0].questionList[0];
              // console.log(this.testForm, "this.testForm")
            });
          });
        }
      });
    },
    //数组排序
    arrSort(arr) {
      return arr.sort((a, b) => {
        return a - b;
      });
    },
    //关闭答题弹窗
    closeShowQuestion() {
      // 判断是否对题目进行作答

      /**保利威替换 start */
      // let midTime = Math.ceil(this.$refs.ycyPlayer.j2s_getDuration() * 0.5) -120;
      /**保利威替换 end */
      /**易测云播放器 start */
      let midTime = Math.ceil(this.$refs.ycyPlayer.getDuration() * 0.5) - 120;
      /**易测云播放器 end */
      // console.log('midTime',midTime)
      if (!this.testForm.checkboxList && !this.testForm.vertical) {
        this.$message({
          message: "请先进行答题才能继续看课",
          type: "warning",
        });
      } else {
        if (this.testForm.questionType == "多选题") {
          let questionAnswersArray = [];
          this.testForm.questionAnswers.forEach((item) => {
            if (item.isRight) {
              questionAnswersArray.push(item.id);
            }
          });
          let lefData = this.arrSort(questionAnswersArray);
          let rigData = this.arrSort(this.testForm.checkboxList);
          // console.log('正确答案已排序',(JSON.stringify(lefData)))
          // console.log('选中答案已排序',(JSON.stringify(rigData)))
          // console.log((JSON.stringify(lefData) === JSON.stringify(rigData)))
          if (JSON.stringify(lefData) === JSON.stringify(rigData)) {
            this.showQuestion = false;
            this.$refs.ycyPlayer.j2s_resumeVideo();
            if (that.questionsTime < 2) {
              this.questionsTime++;
              if (localStorage.getItem("dataType") == 1) {
                this.testForm.checkboxList = undefined;
                this.testForm.vertical = undefined;
                /**保利威替换 start */
                // this.player.j2s_pauseVideo(); // 暂停播放当前视频
                /**保利威替换 end */
                /**易测云播放器 start */
                this.$refs.ycyPlayer.pause(); // 暂停播放当前视频
                /**易测云播放器 end */
                this.showQuestion = true;
                this.getquestion();
              }
            }
          } else {
            this.$message({
              message: "回答错误，需要重新学习本节课程",
              type: "error",
            });
            setTimeout(() => {
              /**保利威视频替换 start */
              // that.player.j2s_seekVideo(midTime);
              /**保利威视频替换 end */

              // ======================== begin 视频进度条异常，回退(旧) begin ========================
              // /**易测云播放器 start */
              // that.$refs.ycyPlayer.jumpToTime(midTime);
              // /**易测云播放器 end */
              // ======================== begin 视频进度条异常，回退(旧) begin ========================

              // ======================== begin 视频进度条异常，回退(新) begin ========================
              that.videoSeekBack(midTime);
              // ======================== end 视频进度条异常，回退(新) end ========================
            }, 1000);
            this.showQuestion = false;
          }
        } else {
          let redioRight = "";
          this.testForm.questionAnswers.forEach((item) => {
            if (item.isRight) {
              redioRight = item.content;
              if (
                JSON.stringify(this.testForm.vertical) ===
                JSON.stringify(redioRight)
              ) {
                localStorage.setItem("haveSeenClass", false);
                this.showQuestion = false;
                /**保利威替换 start */
                // this.player.j2s_resumeVideo();
                /**保利威替换 end */
                /**易测云播放器 start */
                this.$refs.ycyPlayer.play();
                /**易测云播放器 end */
                if (that.questionsTime < 2) {
                  this.questionsTime++;
                  if (localStorage.getItem("dataType") == 1) {
                    this.testForm.checkboxList = undefined;
                    this.testForm.vertical = undefined;
                    /**保利威替换 start */
                    // this.player.j2s_pauseVideo(); // 暂停播放当前视频
                    /**保利威替换 end */
                    /**易测云播放器 start */
                    this.$refs.ycyPlayer.pause(); // 暂停播放当前视频
                    /**易测云播放器 end */
                    this.showQuestion = true;
                    this.getquestion();
                  }
                }
              } else {
                this.$message({
                  message: "回答错误，需要重新学习本节课程",
                  type: "error",
                });
                setTimeout(() => {
                  /**保利威视频替换 start */
                  // that.player.j2s_seekVideo(midTime);
                  /**保利威视频替换 end */

                  // ======================== begin 视频进度条异常，回退(旧) begin ========================
                  // /**易测云播放器 start */
                  // that.$refs.ycyPlayer.jumpToTime(midTime);
                  // /**易测云播放器 end */
                  // ======================== end 视频进度条异常，回退(旧) end ========================

                  // ======================== begin 视频进度条异常，回退(新) begin ========================
                  that.videoSeekBack(midTime);
                  // ======================== end 视频进度条异常，回退(新) end ========================
                }, 1000);
                this.showQuestion = false;
              }
            }
          });
        }
      }
    },
  },
  watch: {
    /**易测云播放start */
    // 监听拍照弹窗，弹出时关闭自动播放
    dialogTableVisible(val) {
      if (val) {
        this.autoPlay = false;
      } else {
        this.autoPlay = true;
      }
    },
    // 监听第20、30分钟弹窗做题，弹出时关闭自动播放
    showQuestion(val) {
      if (val) {
        this.autoPlay = false;
      } else {
        this.autoPlay = true;
      }
    },
    // 监听在线培训满意度调查，弹出时关闭自动播放
    isQuestionShow(val) {
      if (val) {
        this.autoPlay = false;
      } else {
        this.autoPlay = true;
      }
    },
    /**易测云播放end */
  },
};
